import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PowerbiReportClickService {
  public reportClicked = new Subject<void>();
  public reportClicked$ = this.reportClicked.asObservable();

  public sendReportClickedEvent() {
    this.reportClicked.next();
  }
}
